module.exports = __webpack_public_path__ + "static/media/Niveau_elN0_3_534452.3416c2d5.png";